import { render, staticRenderFns } from "./ChangeCompanyModal.vue?vue&type=template&id=4b4bc4ca&scoped=true&"
import script from "./ChangeCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bc4ca",
  null
  
)

export default component.exports